import { render, staticRenderFns } from "./ImageUploadAdd.vue?vue&type=template&id=27b6bc36"
import script from "./ImageUploadAdd.vue?vue&type=script&lang=js"
export * from "./ImageUploadAdd.vue?vue&type=script&lang=js"
import style0 from "./ImageUploadAdd.vue?vue&type=style&index=0&id=27b6bc36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports